import { PoMicroFrontend } from 'micro-frontend.react';

export const DirectDeposit = ({
	employeeId,
	isEmployeeNewHirePacket,
	isNewEmployeeForm,
}) => (
	<PoMicroFrontend
		customClassNamePrefix='employee-pay-info-direct-deposit-tab'
		employeeId={employeeId}
		isEmployeeNewHirePacket={isEmployeeNewHirePacket}
		isNewEmployeeForm={isNewEmployeeForm}
		payroll={{ payrollServicesHost: window.PAYROLLSERVICES_HOST }}
		route='/employees/pay_info/direct_deposit_summary'
	/>
);
